// The inspector workspace's ONE public seam.
//
// Everything else under src/inspection/ is private to the module: the host app
// imports this file and nothing else, so pages, storage and the upload queue can
// be rearranged without touching App.jsx. The module reaches out to exactly two
// shared things (utils/date.js and services/apiClient.js) and is otherwise
// self-contained — keep it that way.
//
// The office's VIEW of inspections (the Inspection tab, Accept, Reset, the
// Inspections To Accept worklist) is deliberately NOT in here. That is office
// code about inspections, not the inspector's app.

import { Route } from "react-router-dom";
import { InspectionAccessRoute } from "./InspectionRoutes.jsx";
import InspectionLayout from "./InspectionLayout.jsx";
import InspectionHomePage from "./pages/InspectionHomePage.jsx";
import InspectionJobPage from "./pages/InspectionJobPage.jsx";
import InspectionJobSheetPage from "./pages/InspectionJobSheetPage.jsx";

/**
 * The whole workspace as one <Route> subtree, for mounting inside the app's
 * authenticated <Routes>. Access (workspace enabled + Inspector group) is
 * enforced here as well as on the API.
 */
export function inspectionRoutes({ currentUser, setCurrentUser }) {
  return (
    <Route element={<InspectionAccessRoute currentUser={currentUser} />}>
      <Route
        path="/inspection"
        element={<InspectionLayout currentUser={currentUser} setCurrentUser={setCurrentUser} />}
      >
        <Route index element={<InspectionHomePage currentUser={currentUser} />} />
        <Route path=":inspectionId" element={<InspectionJobPage currentUser={currentUser} />} />
        {/* The printed job sheet, on the phone — its own screen so the photo
            screen stays about photos. */}
        <Route path=":inspectionId/sheet" element={<InspectionJobSheetPage currentUser={currentUser} />} />
      </Route>
    </Route>
  );
}

// Who the workspace is for — defined in ./access.js and re-exported here so the
// host app has a single import for everything the module offers.
export { usesInspectionWorkspace, isInspectionOnlyUser, INSPECTION_HOME } from "./access.js";
